/**
 * Get the first letter of the username
 *
 * @param name username
 * @returns the first letter of the username
 */
export const getInitials = (name: string) => {
  return name.charAt(0).toUpperCase();
};
